module.exports = __webpack_public_path__ + "static/media/outline_Rear_Tire.05af761d.svg";